import axios from '../../helpers/axiosConfig';
import { customSelect } from '../../functions/custom-forms';
import { el } from '../../functions/create-element';
export function faqRatings() {
    const ratings = document.querySelectorAll('.faq-rating');
    ratings.forEach(rating => {
        if (!rating)
            return;
        const url = rating.getAttribute('data-url');
        const faq_id = rating.getAttribute('data-id');
        const question_id = rating.getAttribute('data-question');
        const send = (answer) => {
            axios.post(url, {
                faq_id: faq_id,
                question_id: question_id,
                answer: answer
            }).then((response) => {
                if (response.data == 1) {
                    rating.innerHTML = __('Dziękujemy za podzielenie się opinią.');
                }
                else {
                    rating.innerHTML = __('Podzieliłeś już się z nami opinią w tym temacie.');
                }
            });
        };
        const buttons = rating.querySelectorAll('button[name=answer');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const value = button.getAttribute('value');
                send(value);
            });
        });
    });
}
export function faqAsist() {
    const asist = document.querySelector('.faq-asist');
    if (!asist)
        return;
    const questionsContainer = asist.querySelector('.questions');
    const resultContainer = asist.querySelector('.asist-result');
    const resultTopic = asist.querySelector('.result-title');
    const resultAnswer = asist.querySelector('.result-answer');
    const url = asist.getAttribute('data-url');
    const topicSelect = document.getElementById('topic');
    const questionsSelect = document.getElementById('question');
    const removeChilds = (parent) => {
        while (parent.firstChild) {
            parent.removeChild(parent.firstChild);
        }
    };
    const getTopic = (id) => {
        axios.post(url, { topic: id }).then(response => {
            const questions = response.data.questions;
            if (questions.length == 0) {
                questionsContainer.style.display = "none";
            }
            else {
                questionsSelect.classList.remove('custom-select-hidden');
                questionsSelect.nextSibling.remove();
                removeChilds(questionsSelect);
                const empty = el('option', { selected: 'selected', value: '' }, __('-- Wybierz --'));
                questionsSelect.appendChild(empty);
                for (const id in questions) {
                    questionsSelect.appendChild(el('option', { value: id }, questions[id]));
                }
                customSelect();
                questionsContainer.style.display = "block";
            }
            resultContainer.style.display = "none";
        });
    };
    const getAnswer = (id) => {
        axios.post(url, { question: id }).then(response => {
            const result = response.data.result;
            if (result.length == 0) {
                resultContainer.style.display = "none";
            }
            else {
                resultTopic.innerHTML = result.question;
                resultAnswer.innerHTML = result.answer;
                resultContainer.style.display = "block";
            }
        });
    };
    topicSelect.addEventListener('change', () => {
        const value = topicSelect.value;
        getTopic(value);
    });
    questionsSelect.addEventListener('change', () => {
        const value = questionsSelect.value;
        getAnswer(value);
    });
}
